import { getToken } from '../user/tokens'
import axios from 'axios'

export function removeDevice(deviceId, platform) {
  return getToken().then( token => {
    return axios({
      method: 'DELETE',
      url: `${window.settings.apiBaseUrl}/user/device/desync`,
      // url: `https://develop-api.viewlift.com/identity/device/${deviceId}`,
      headers: { 
        'Authorization': token,
        'x-api-key': window.settings.baseAPIKey
      },
      params: {
        site: window.settings.internalName,
        deviceId: deviceId,
        platform: platform
      }
    }).then( res => {
      console.log('Removed device')
    }).catch( err => {
      console.log('Could not remove device')
    })
  })
}

export function fetchDevices(userId) {
  return getToken().then( token => {
    return axios({
      method: 'GET',
      url: `${window.settings.apiBaseUrl}/user/device?site=${window.settings.internalName}&userId=${userId}`,
      // url: 'https://develop-api.viewlift.com/identity/device?site=snagfilms&userId=aws-111',
      headers: { 
        'Authorization': token,
        'x-api-key': window.settings.baseAPIKey
      }
    })
    .then(x => (x && x.data && x.data.Items) || [])
  })
}


export function activateDevice(code, userId) {
  return getToken().then(token => {
    return axios({
      method: 'POST',
      url: `${window.settings.apiBaseUrl}/user/device/sync?site=${window.settings.internalName}`,
      // url: 'https://develop-api.viewlift.com/identity/device?site=snagfilms&userId=aws-111',
      headers: { 
       'Authorization': token,
       'x-api-key': window.settings.baseAPIKey
      },
      data: {
        'activationCode': `${code}`,
        'userId': `${userId}`
      }
    })
  })
}

